
import { compose } from 'redux'
import { connect } from 'react-redux'

import configs from '../../../../routes'
import { getConfigsDinamic } from '../../../../routes/sistema/DinamicForms/functions'


const mapStateToProps = (state, props) => {
    let permissoes = []
    addPermissoes(configs, permissoes)
    addPermissoes(getConfigsDinamic(state), permissoes)
    permissoes.sort();
    return { opcoes: permissoes, label: "Permissões Gerais" };
};


export default compose(
    connect(mapStateToProps, {}),
);


function addPermissoes(configs, permissoes) {


    if (configs.menu) {
        if (configs.menu.permissao) {
            permissoes.push(configs.menu.permissao)
        }


    }
    if (configs.subConfig) {
        configs.subConfig.forEach(((sub, i) => addPermissoes(sub, permissoes)))
    }
}




// WEBPACK FOOTER //
// ./src/modules/permissoes/components/ArvorePermissoesGeral/ArvorePermissoesGeral.enhancer.js